import { EntityLink } from '@/shared/ui/entity-link'

interface EntityRefProps {
  id: string
  label?: string
  className?: string
}

export function AccountLink({ id, label, className }: EntityRefProps) {
  return (
    <EntityLink
      to="/telephony/accounts/$accountId"
      params={{ accountId: id }}
      icon="id-card"
      mono
      className={className}
    >
      {label ?? id}
    </EntityLink>
  )
}

export function PoolLink({ id, label, className }: EntityRefProps) {
  return (
    <EntityLink
      to="/telephony/pools/$poolId"
      params={{ poolId: id }}
      icon="layers"
      mono
      className={className}
    >
      {label ?? id}
    </EntityLink>
  )
}

export function ProfileLink({ id, label, className }: EntityRefProps) {
  return (
    <EntityLink
      to="/telephony/profiles/$profileId"
      params={{ profileId: id }}
      icon="phone"
      mono
      className={className}
    >
      {label ?? id}
    </EntityLink>
  )
}
